module.exports = __webpack_public_path__ + "img/logo-min.d5800c31.svg";